/**
 * Inline trend line for one Resource across the visible months (spec D2). Hand-rolled
 * SVG — no chart library exists in this stack (see PodDemand). Null months
 * are gaps, not zeros: the line only joins months that have a value.
 */
const W = 84;
const H = 22;
const PAD = 2;

export function Sparkline({ values, label }: { values: Array<number | null>; label: string }) {
  const present = values.filter((v): v is number => v !== null);
  if (present.length === 0) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }
  const max = Math.max(...present, 1);
  const step = values.length > 1 ? (W - PAD * 2) / (values.length - 1) : 0;
  const points = values.flatMap((v, i) =>
    v === null ? [] : [{ x: PAD + i * step, y: H - PAD - (v / max) * (H - PAD * 2) }],
  );
  return (
    <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} role="img" aria-label={label}>
      {points.length > 1 && (
        <polyline
          points={points.map((p) => `${p.x},${p.y}`).join(" ")}
          fill="none"
          stroke="var(--brand-600)"
          strokeWidth={1.5}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      )}
      {points.map((p) => (
        <circle key={`${p.x}`} cx={p.x} cy={p.y} r={1.75} fill="var(--brand-600)" />
      ))}
    </svg>
  );
}
